var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24624_287794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14.5625C6.00952 14.5625 4.34032 13.8711 3.10961 12.6404C1.8789 11.4097 1.1875 9.74048 1.1875 8C1.1875 6.25952 1.8789 4.59032 3.10961 3.35961C4.34032 2.1289 6.00952 1.4375 7.75 1.4375C9.49048 1.4375 11.1597 2.1289 12.3904 3.35961C13.6211 4.59032 14.3125 6.25952 14.3125 8C14.3125 9.74048 13.6211 11.4097 12.3904 12.6404C11.1597 13.8711 9.49048 14.5625 7.75 14.5625ZM7.75 15.5C9.73912 15.5 11.6468 14.7098 13.0533 13.3033C14.4598 11.8968 15.25 9.98912 15.25 8C15.25 6.01088 14.4598 4.10322 13.0533 2.6967C11.6468 1.29018 9.73912 0.5 7.75 0.5C5.76088 0.5 3.85322 1.29018 2.4467 2.6967C1.04018 4.10322 0.25 6.01088 0.25 8C0.25 9.98912 1.04018 11.8968 2.4467 13.3033C3.85322 14.7098 5.76088 15.5 7.75 15.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62183 6.67625L6.47495 6.94531L6.39808 7.30156L6.81995 7.37937C7.09558 7.445 7.14995 7.54437 7.08995 7.81906L6.39808 11.0703C6.21621 11.9112 6.49652 12.3069 7.15558 12.3069C7.66652 12.3069 8.25995 12.0706 8.52902 11.7462L8.61152 11.3562C8.42402 11.5212 8.15027 11.5869 7.96839 11.5869C7.71058 11.5869 7.61683 11.4059 7.68339 11.0872L8.62183 6.67625ZM8.68745 4.71875C8.68745 4.96739 8.58868 5.20585 8.41287 5.38166C8.23705 5.55748 7.9986 5.65625 7.74995 5.65625C7.50131 5.65625 7.26286 5.55748 7.08704 5.38166C6.91123 5.20585 6.81245 4.96739 6.81245 4.71875C6.81245 4.47011 6.91123 4.23165 7.08704 4.05584C7.26286 3.88002 7.50131 3.78125 7.74995 3.78125C7.9986 3.78125 8.23705 3.88002 8.41287 4.05584C8.58868 4.23165 8.68745 4.47011 8.68745 4.71875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24624_287794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoUser);
export default __webpack_public_path__ + "static/media/info_user.7758e1ea03227d3814d0650050d4efff.svg";
export { ForwardRef as ReactComponent };